import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";

import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import ExamReportSection from '../components/home/ExamReportSection';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import moment from 'moment';
import { withRouter, Link } from "react-router-dom";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";


const GET_GLOBALS = gql`
 query($institution_id: Int!,$userName: String) {
          globals(institution_id: $institution_id,userName: $userName) {
            organisationDropdown{
              id
              group_name
            }          
            classes{
              id
              class
            }
            globalSections{
              id
              section_name
              branch_id
              exam_id
              category_id
            }
            exams{
              id
              exam
              exam_subjects{
                subject_id
              }
          }
            subjects{
              id
              subject
            }
            testNames{
     id
     exam_name
     type
     exam_type
     is_completed
     start_time
     end_time
   }
   testTypes{
     id
     type
   }
          }
        }
`;
const FETCH_SECTIONS = gql` 
query($institution_id: Int!) {
    getSections(institution_id: $institution_id){
        id
        section_name
        branch_id
    }
}

`;

const FETCH_EXAMS = gql`
query($institution_id: Int!){
  getDashBoardExams(institution_id : $institution_id){
    quiz_exams{
      id
      exam_name
      exam_type
      class_id
      start_time

    }
    full_exams{
      id
      exam_name
      exam_type
      class_id
      start_time
      section{
        id
        section_name
        branch_id
        exam_id
      }
    }
  }
}
`;

class ExamReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      eexamptype: props.history.location.state?.examsglobals[0].id,
      eexamptypeValue: { value: props.history.location.state?.examsglobals[0].id, label: props.history.location.state?.examsglobals[0].exam },
      esection: "0",
      esectionValue: { value: "0", label: "Select All" },

    }
  }
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  }


  //
  render() {

    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;

    const getSections = this.props.getSections;
    const loading2 = getSections.loading;
    const error2 = getSections.error;

    const getDashBoardExams = this.props.getDashBoardExams
    const loading3 = getDashBoardExams.loading
    const error3 = getDashBoardExams.error

    console.log("getDashBoardExams", getDashBoardExams)


    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }

    return (

      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            {
              loading1 || loading2 || loading3 ?
                (
                  <Container>
                    <Row>
                      <Col sm={12} className="d-flex justify-content-center align-items-center vh-100">
                        <div className="spinner-border text-primary" role="status"></div>
                      </Col>
                    </Row>
                  </Container>
                )
                :
                (
                  <ExamReportSection
                    globals={globals.globals}
                    getSections={getSections.getSections}
                    stateData={this.state}
                    getDashBoardExams={getDashBoardExams.getDashBoardExams}
                  />
                )
            }

          </div>
        </div>
      </div>


    );
  }
}

export default withRouter(
  compose(
    graphql(
      GET_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
            userName: Cookies.get("username")
          },
          fetchPolicy: 'network-only'
        }),
        name: "globals"
      }
    ),
    graphql(FETCH_SECTIONS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        }), name: "getSections"
      }),
    graphql(FETCH_EXAMS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        }), name: "getDashBoardExams"
      }),

  )(ExamReport)
);
